export const ZhChtStarredMessagesStrings = {
  
  ERROR_MSG: {
    IN_INIT_CHATROOM: "聊天室正在初始化中, 請稍後再試"
  }
}
